import React, { useEffect, useRef } from "react";

export const ADSENSE_CLIENT = "ca-pub-6585219991395423";

// Reusable Google AdSense display unit.
// Pass `slot` = the AdSense ad-unit ID (from your AdSense dashboard).
// Leave `slot` empty to render a responsive placeholder until units are wired.
export function AdSense({
  slot = "",
  format = "auto",
  responsive = true,
  className = "",
  style = { display: "block" },
  testId,
}) {
  const insRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    if (!insRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      /* AdSense not ready yet */
    }
  }, []);

  return (
    <ins
      ref={insRef}
      className={`adsbygoogle ${className}`}
      style={style}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot || undefined}
      data-ad-format={format}
      data-full-width-responsive={responsive ? "true" : "false"}
      data-testid={testId}
    />
  );
}
